import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { replace } from "lodash";
import {
	Dialog,
	DialogTitle,
	IconButton,
	DialogContent,
	FormControlLabel,
	TextField,
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	Select,
	OutlinedInput,
	MenuItem,
	Checkbox,
	ListItemText,
	ImageList,
	ImageListItem,
	ImageListItemBar,
	CircularProgress,
} from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Close as CloseIcon } from "@mui/icons-material";
import Delete from "@mui/icons-material/Delete";
import { showLoading } from "../../../redux/actions/campaign.actions";
import { checkCharSize, validateimg } from "../../../utils/Validations";
import axiosInstance from "../../../utils/axiosInterceptor";
import BankCodes from './bankCode.json'
import { toast } from "react-hot-toast";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": { padding: theme.spacing(2) },
	"& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

function srcset(image, size, rows = 2, cols = 2) {
	return {
		src: `${image}`,
		srcSet: `${image}?w=${size * cols}&h=${size * rows
			}&fit=crop&auto=format&dpr=2 2x`,
	};
}

function BootstrapDialogTitle(props) {
	const { children, onClose, ...other } = props;


	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label='close'
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon />
				</IconButton>
			) : null}
		</DialogTitle>
	);
}

BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};

const CreateModel = (props) => {
	const host = `${process.env.REACT_APP_BASE_URL_VMS}/`;
	const {
		open,
		openCreateModel,
		setOpenCreateModel,
		collectionData,
		handleAlert,
		refreshDetails,
		isEdit,
		campaignId,
		campaignList,
		setIsEdit,
		updateCampaignData,
		types,
		setTypes,
		setCampaignData,
		campaignData,
	} = props;

	const { user } = useSelector((state) => state.authReducer);
	const { loading } = useSelector((state) => state.campaignReducer);
	const { loading: collectionLoading } = useSelector((state) => state?.collectionNewReducer);
	const [imageUrls, setImageUrls] = useState([]);

	const dispatch = useDispatch();

	useEffect(() => {
		if (isEdit && updateCampaignData) {
			setImageUrls(updateCampaignData?.images || []);
			setCampaignData(updateCampaignData);
		}
	}, [isEdit, updateCampaignData]);

	const [imageData, setImageData] = useState({});
	const [idArray, setIdArray] = useState([]);
	
	const [deletedImageUrl, setDelatedImageUrls] = useState([]);
	//regex for positive numbers only
	const regexPositiveNo = /^[0-9\b]+$/;
	useEffect(() => {

	}, [])


	const handleClose = () => {
		setIsEdit(false);
		setImageData({});
		setIdArray([]);
		setImageUrls("")
		setOpenCreateModel(false);
	};

	const isTitleAlreadyExits = (title) => {
		return campaignList.find(obj => obj.title == title && obj.id != campaignId) ? true : false
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		dispatch(showLoading(true));
		if (!isEdit) {
			try {
				const formData = new FormData();
				if (Object.keys(imageData).length == 0) {
					alert("Select banner image.");
					dispatch(showLoading(false));
					return;
				}
				formData.append("banner", imageData[0]);
				if (idArray.length == 1) {
					formData.append("collection_id[]", idArray[0]);
				} else {
					for (let i = 0; i < idArray.length; i++) {
						formData.append("collection_id", idArray[i]);
					}
				}
				formData.append("created_by", user.user_name);
				formData.append("modified_by", user.user_name);
				formData.append("verified_by", user.user_name);
				for (let item in campaignData) {
					if (item == "title" && isTitleAlreadyExits(campaignData[item])) {
						dispatch(showLoading(false));
						alert("Campaign title already exists.");
						return;
					}
					formData.append(item, campaignData[item]);
				}
				const res = await axiosInstance.post(`${host}api/v1/campaigns`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
						"Access-Control-Allow-Origin": "*",
					},
				});
				const {
					data: { data, msg },
					status,
				} = res || {};
				dispatch(showLoading(false));
				toast.success(msg);
				refreshDetails();
				setCampaignData({});
				setTypes({
					pay_type: "",
					pay_method: "",
					bankcode: ""
				});
				toast.success("Campaign created successfully");
				handleClose();
			} catch (err) {
				handleAlert(err, "error");
				toast.error("Something went wrong while creating campaign");
				dispatch(showLoading(false));
				handleClose();
				setCampaignData({});
				setTypes({
					pay_type: "",
					pay_method: "",
					bankcode: ""
				});
			}
		} else {
			try {
				const formData = new FormData();

				for (let i = 0; i < imageData.length; i++) {
					formData.append("banner", imageData[i]);
				}
				for (let i = 0; i < campaignData?.collections.length; i++) {
					formData.append("collection_id[]", campaignData?.collections[i]);
				}
				for (let i = 0; i < idArray.length; i++) {
					formData.append("collection_id", idArray[i]);
				}

				for (let i = 0; i < deletedImageUrl.length; i++) {
					formData.append("image_urls[]", deletedImageUrl[i]);
				}

				formData.append("modified_by", user.user_id);
				for (let item in campaignData) {
					if (item == "title" && isTitleAlreadyExits(campaignData[item])) {
						dispatch(showLoading(false));
						alert("Campaign title already exists.");
						return;
					}
					formData.append(item, campaignData[item]);
				}
				formData.delete("collections");
				formData.delete("is_deleted");

				const res = await axiosInstance.patch(
					`${host}api/v1/campaigns/${campaignId}`,
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Access-Control-Allow-Origin": "*",
						},
					}
				);
				const {
					data: { data, msg },
					status,
				} = res || {};
				toast.success(msg);
				refreshDetails();
				setCampaignData({});
				setTypes({
					pay_type: "",
					pay_method: "",
					bankcode: ""
				});
				dispatch(showLoading(false));
				toast.success("Campaign updated successfully");
				handleClose();
			} catch (err) {
				handleAlert(err, "error");
				toast.error(err?.response?.data?.message);
				dispatch(showLoading(false));
				handleClose();
				setCampaignData({});
				setTypes({
					pay_type: "",
					pay_method: "",
					bankcode: ""
				});
			}
		}
	};


	const handleChange = (e) => {
		const { name, value } = e.target;
		 const valueType=Number(value);

		if(name =="amount" && isNaN(valueType)){
		alert("Amount should be a number");
		return;
		}
		setCampaignData((prev) => ({
			...prev,
			[name]: value,
		}));
	};


	const handleFileChange = async (e) => {
		const size = e.target.files[0].size;
		if (size > 1048576) {
			alert("Upload an image of size less than 1 MB.");
			return;
		}

		setImageData(e.target.files);
		setImageUrls([...imageUrls, URL.createObjectURL(e.target.files[0])]);
	};


	const updateImageUrls = (e, item) => {
		setDelatedImageUrls([...deletedImageUrl, item]);
		setImageUrls((current) => current.filter((value) => item !== value));
	};

	const selectedIds = idArray;

	const selectedCollections = useMemo(() => {
		return collectionData?.filter((item) =>
			selectedIds.includes(item.collection_id)
		);
	}, [selectedIds, collectionData]);

	const unselectedCollections = collectionData?.filter((item) =>
		!selectedIds.includes(item.collection_id)
	);


	useEffect(() => {
		if (campaignData?.collections) {
			setIdArray(campaignData.collections.map((item) => item.collection_id));
		}
	}, [campaignData]);


	const handleChangeCollection = (event) => {
		const {
			target: { value },
		} = event;

		const updated = typeof value === "string" ? value.split(",") : value;
		setIdArray(updated);
	};


	return (
		<BootstrapDialog
			onClose={handleClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			maxWidth="md"
			fullWidth
			scroll="paper"
			PaperProps={{
				sx: {
					borderRadius: 3,
					overflow: "hidden",
					maxHeight: "92vh",
					border: "1px solid rgba(148, 163, 184, 0.35)",
					background: "#ffffff",
				},
			}}
			BackdropProps={{
				sx: {
					backdropFilter: "blur(6px)",
					backgroundColor: "rgba(2, 6, 23, 0.6)",
				},
			}}
		>
			<BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
				{isEdit ? `Update Campaign` : `Create Campaign`}
			</BootstrapDialogTitle>

			<DialogContent dividers sx={{ overflowY: "auto", maxHeight: "calc(92vh - 64px)" }}>
				<form onSubmit={handleSubmit}>
					<Grid container spacing={3}>

						{/* Title */}
						<Grid item xs={12} sm={6}>
							<TextField
								required
								fullWidth
								id="title"
								name="title"
								label="Title"
								placeholder="Enter campaign title"
								onChange={handleChange}
								value={campaignData.title || ""}
								helperText={`${50 - (campaignData.title?.length || 0)} characters left`}
							/>
						</Grid>

						{/* URL */}
						<Grid item xs={12} sm={6}>
							<TextField
								required
								fullWidth
								id="url"
								label="URL"
								name="url"
								placeholder="Enter URL"
								onChange={handleChange}
								value={campaignData.url || ""}
							/>
						</Grid>

						{/* Description */}
						<Grid item xs={12}>
							<TextField
								required
								fullWidth
								id="description"
								name="description"
								label="Description"
								placeholder="Enter description"
								onChange={handleChange}
								value={campaignData.description || ""}
								helperText={`${100 - (campaignData.description?.length || 0)} characters left`}
							/>
						</Grid>

						{/* Amount */}
						<Grid item xs={12} sm={4}>
							<TextField
								fullWidth
								id="amount"
								label="Amount"
								name="amount"
								placeholder="Enter amount"
								onChange={handleChange}
								value={campaignData.amount || ""}
							/>
						</Grid>
						<Grid item xs={12} sm={8}>
							{
								collectionLoading ?
									<CircularProgress />
									:
									<>
										<FormControl fullWidth>
											<InputLabel id="collection-multiple-checkbox-label">Collections</InputLabel>
											<Select
												labelId="collection-multiple-checkbox-label"
												id="collection-multiple-checkbox"
												multiple
												required
												name="collections"
												value={selectedIds}
												onChange={handleChangeCollection}
												input={<OutlinedInput label="Collections" />}
												renderValue={(selected) =>
													selected
														.map((id) =>
															collectionData.find((obj) => obj.collection_id === id)?.collection_name
														)
														.join(", ")
												}
												MenuProps={MenuProps}
											>
												{selectedCollections?.map((name) => (
													<MenuItem key={name.collection_id} value={name.collection_id}>
														<Checkbox checked={selectedIds.includes(name.collection_id)} />
														<ListItemText primary={name.collection_name} />
													</MenuItem>
												))}

												{unselectedCollections?.map((name) => (
													<MenuItem key={name.collection_id} value={name.collection_id}>
														<Checkbox checked={false} />
														<ListItemText primary={name.collection_name} />
													</MenuItem>
												))}
											</Select>

										</FormControl>
									</>
							}
						</Grid>

						{/* Pay Type */}
						<Grid item xs={12} sm={4}>
							<FormControl fullWidth>
								<InputLabel id="pay_type" >Pay Type</InputLabel>
								<Select
									labelId="pay_type"
									name="pay_type"
									value={types?.pay_type || campaignData.pay_type || ""}
									onChange={handleChange}

									label="Pay Type"
								>
									<MenuItem value="payU">PayU</MenuItem>
									<MenuItem value="razorPay">Razor Pay</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						{/* Pay Method */}
						<Grid item xs={12} sm={4}>
							<FormControl fullWidth>
								<InputLabel id="pay_method">Pay Method</InputLabel>
								<Select
									labelId="pay_method"
									name="pay_method"
									value={types?.pay_method || campaignData.pay_method || ""}
									onChange={handleChange}
									label="Pay Method"
								>
									<MenuItem value="creditcard|debitcard|netbanking|wallet|upi">All</MenuItem>
									<MenuItem value="creditcard|debitcard">creditcard | debitcard</MenuItem>
									<MenuItem value="debitcard">debitcard</MenuItem>
									<MenuItem value="creditcard">creditcard</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						{/* Bank Code */}
						<Grid item xs={12} sm={4}>
							<FormControl fullWidth>
								<InputLabel id="bankcode">Bank Code</InputLabel>
								<Select
									labelId="bankcode"
									name="bankcode"
									value={types?.bankcode || campaignData.bankcode || ""}
									onChange={handleChange}
									label="Bank Code"
								>
									{BankCodes?.map((item, index) => (
										<MenuItem value={item.bankcode} key={index}>
											{item.bankname}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>

						{/* Existing Images (Edit Mode) */}
						{isEdit ? (
							<Grid item xs={12}>
								<Box
									sx={{
										display: 'grid',
										gridTemplateColumns: `repeat(${imageUrls?.length || 1}, 1fr)`,
										gap: 1,
										width: '100%',
									}}
								>
									<Box
										sx={{
											display: 'grid',
											gridTemplateColumns: `repeat(${imageUrls?.length || 1}, 1fr)`,
											gap: 1,
											width: '100%',
										}}
									>
										{Array.isArray(imageUrls) &&
											imageUrls.map((item) => (
												<Box
													key={item}
													sx={{ position: 'relative', height: 100, borderRadius: 1, overflow: 'hidden' }}
												>
													<Button
														onClick={(e) => updateImageUrls(e, item)}
														sx={{
															p: 0,
															width: '100%',
															height: '100%',
															borderRadius: 1,
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
															position: 'relative',
															minWidth: 0,
														}}
													>
														<img
															src={item}
															alt="Image not found"
															loading="lazy"
															style={{
																maxWidth: '100%',
																maxHeight: '100%',
																objectFit: 'contain',
																borderRadius: 8,
																pointerEvents: 'none',
																userSelect: 'none',
															}}
														/>
														<Delete
															fontSize="small"
															sx={{
																position: 'absolute',
																top: 4,
																right: 4,
																color: 'white',
																backgroundColor: 'red',
																borderRadius: '50%',
																zIndex: 1,
																animation: 'pulse 2s infinite',
																'@keyframes pulse': {
																	'0%': {
																		transform: 'scale(1)',
																		boxShadow: '0 0 0 0 rgba(255,0,0, 0.7)',
																	},
																	'70%': {
																		transform: 'scale(1.1)',
																		boxShadow: '0 0 8px 8px rgba(255,0,0, 0)',
																	},
																	'100%': {
																		transform: 'scale(1)',
																		boxShadow: '0 0 0 0 rgba(255,0,0, 0)',
																	},
																},
															}}
														/>
													</Button>
												</Box>
											))}
									</Box>

								</Box>
							</Grid>
						)
							: (
								<Grid item xs={12}>
									<Box
										sx={{
											display: 'grid',
											gridTemplateColumns: `repeat(${imageUrls?.length || 1}, 1fr)`,
											gap: 1,
											width: '100%',
										}}
									>
										<Box
											sx={{
												display: 'grid',
												gridTemplateColumns: `repeat(${imageUrls?.length || 1}, 1fr)`,
												gap: 1,
												width: '100%',
											}}
										>
											{Array.isArray(imageUrls) &&
												imageUrls.map((item) => (
													<Box
														key={item}
														sx={{ position: 'relative', height: 100, borderRadius: 1, overflow: 'hidden' }}
													>
														<Button
															onClick={(e) => updateImageUrls(e, item)}
															sx={{
																p: 0,
																width: '100%',
																height: '100%',
																borderRadius: 1,
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																position: 'relative',
																minWidth: 0,
															}}
														>
															<img
																src={item}
																alt="Image not found"
																loading="lazy"
																style={{
																	maxWidth: '100%',
																	maxHeight: '100%',
																	objectFit: 'contain',
																	borderRadius: 8,
																	pointerEvents: 'none',
																	userSelect: 'none',
																}}
															/>
															<Delete
																fontSize="small"
																sx={{
																	position: 'absolute',
																	top: 4,
																	right: 4,
																	color: 'white',
																	backgroundColor: 'red',
																	borderRadius: '50%',
																	zIndex: 1,
																	animation: 'pulse 2s infinite',
																	'@keyframes pulse': {
																		'0%': {
																			transform: 'scale(1)',
																			boxShadow: '0 0 0 0 rgba(255,0,0, 0.7)',
																		},
																		'70%': {
																			transform: 'scale(1.1)',
																			boxShadow: '0 0 8px 8px rgba(255,0,0, 0)',
																		},
																		'100%': {
																			transform: 'scale(1)',
																			boxShadow: '0 0 0 0 rgba(255,0,0, 0)',
																		},
																	},
																}}
															/>
														</Button>
													</Box>
												))}
										</Box>
									</Box>
								</Grid>
							)
						}

						<Grid item xs={12}>
							<FormControl fullWidth>
								<Button variant="outlined" component="label" sx={{ textTransform: "none" }}>
									Upload Banners
									<input
										hidden
										onChange={handleFileChange}
										accept=".png, .jpg, .jpeg"
										multiple
										type="file"
										required={!isEdit}
									/>
								</Button>
							</FormControl>
						</Grid>
					</Grid>

					<Box sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}>
						<Button onClick={handleClose} variant="outlined" color="error" sx={{ px: 4, py: 1 }}>
							Close
						</Button>
						<Button
							type="submit"
							disabled={loading}
							variant="contained"

							sx={{ px: 4, py: 1, background: "#7469f1" }}
						>
							{isEdit ? "Update" : "Create"}
						</Button>
					</Box>
				</form>
			</DialogContent>
		</BootstrapDialog>

	);
};

export default CreateModel;
